
export function getCompetitionId( competitionTypeId, competitionOptions) {
    return competitionOptions.filter(group => group.id === +competitionTypeId)[0]['active-contest']
}

